import ar from '../locales/ar.js';
import en from '../locales/en.js';

export const LANGUAGE_KEY = 'bh-language';
export const dictionaries = { ar, en };
export const normalizeLanguage = (value) => value === 'en' ? 'en' : 'ar';
export const directionOf = (language) => normalizeLanguage(language) === 'en' ? 'ltr' : 'rtl';
export const localeOf = (language) => normalizeLanguage(language) === 'en'
  ? 'en-SA-u-nu-latn-ca-gregory' : 'ar-SA-u-nu-latn-ca-gregory';

export function readLanguage(storage) {
  try { return normalizeLanguage(storage.getItem(LANGUAGE_KEY)); } catch { return 'ar'; }
}

export function translate(language, key, params = {}) {
  const lang = normalizeLanguage(language);
  let message = dictionaries[lang][key] ?? ar[key] ?? key;
  if (typeof message === 'object') {
    const form = new Intl.PluralRules(lang).select(Number(params.count));
    message = message[form] ?? message.other;
  }
  return message.replace(/\{(\w+)\}/g, (match, name) => params[name] === undefined ? match : String(params[name]));
}

export function applyLanguage(language, doc) {
  const lang = normalizeLanguage(language);
  doc.documentElement.lang = lang;
  doc.documentElement.dir = directionOf(lang);
  doc.title = translate(lang, 'app.title');
}

export function saveLanguage(language, storage, doc) {
  const lang = normalizeLanguage(language);
  try { storage.setItem(LANGUAGE_KEY, lang); } catch { /* الاختيار يعمل حتى إن حُجب التخزين */ }
  applyLanguage(lang, doc);
  return lang;
}

export const formatMoney = (language, value) => new Intl.NumberFormat(localeOf(language), {
  style: 'currency', currency: 'SAR', minimumFractionDigits: 2,
}).format(Number(value || 0));
export const formatNumber = (language, value) => new Intl.NumberFormat(localeOf(language), {
  maximumFractionDigits: 2,
}).format(Number(value || 0));
export const formatDateTime = (language, value) => value ? new Intl.DateTimeFormat(localeOf(language), {
  dateStyle: 'medium', timeStyle: 'short', timeZone: 'Asia/Riyadh',
}).format(new Date(`${value.replace(' ', 'T')}Z`)) : '—';

export function translateError(language, error) {
  if (!error) return '';
  const key = `errors.${error.code || ''}`;
  if (ar[key]) return translate(language, key, error.params);
  if (error instanceof TypeError) return translate(language, 'errors.network');
  return error.message || String(error);
}
